import { useEffect, useState } from 'react';
import { SignIn } from '@crave/ui';
import {
  authProblem,
  authProviders,
  requestPasswordReset,
  resendConfirmation,
  sendEmailCode,
  signInWithApple,
  signInWithPassword,
  verifyEmailCode,
} from '../lib/auth.ts';

export function Login() {
  const [apple, setApple] = useState(false);
  useEffect(() => {
    void authProviders().then((p) => setApple(p.apple));
  }, []);
  return (
    <main style={{ maxWidth: 440, margin: '6vh auto', padding: 24 }}>
      <SignIn
        title="Crave Admin"
        subtitle="For the owner and managers."
        logoSrc="/brand/logo-color-480.png"
        problem={authProblem}
        appleEnabled={apple}
        onApple={() => signInWithApple('/')}
        onPassword={signInWithPassword}
        onSendCode={(email) => sendEmailCode(email, '/')}
        onVerifyCode={verifyEmailCode}
        onForgotPassword={requestPasswordReset}
        onResendConfirmation={(email) => resendConfirmation(email, '/')}
        footer={
          <p style={{ margin: 0, fontSize: 13, color: 'var(--ink-soft)' }}>
            Staff logins are created by the owner under Staff. Forgot your password? Use Forgot
            password. Customers order at order.cravepizzafl.com.
          </p>
        }
      />
    </main>
  );
}
